// extracted by mini-css-extract-plugin
module.exports = {"banner":"_93ea606c","printLink":"_20d88709"};